import { createContext } from "react";

import { Organization } from "@medplum/fhirtypes";

import type {
  DevelopmentFeatureFlags,
  PracticeFeatureFlags,
} from "@/feature-flags/constants/feature-flags";
import { PractitionerPermissionFlags } from "@/permission/constants/practitioner-permissions";

interface OrganizationsContextOptions {
  organizations: Organization[];
  permissions: PractitionerPermissionFlags[];
  features: { practice: PracticeFeatureFlags[]; development: DevelopmentFeatureFlags[] };
  /**
   * Re-reads an Organization from Medplum and updates the in-memory org list.
   * When the id matches the user's active practice, feature gates in context update immediately.
   */
  refreshOrganizationFeaturesFromMedplum: (organizationId: string) => Promise<void>;
}

export const OrganizationsContext = createContext<OrganizationsContextOptions>({
  organizations: [],
  permissions: [],
  features: { practice: [], development: [] },
  refreshOrganizationFeaturesFromMedplum: async () => {},
});
